import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import { Row, Col, Form } from 'react-bootstrap';
import { CustomButton, CustomSelect } from 'components/CustomForm';
import { getInputs } from 'network/apis/CommonApi';
import { Card, EmptyLabel, VDivider } from 'components/CommonWidgets';
import CommonTable from 'components/CommonTable';
import PersianPickerTile from 'components/PersianPickerTile';
import { PersianDate } from 'helpers/dates';
import { getNonRegisteredBuysReport, getNonRegisteredDistsReport } from 'network/apis/ReportingApi';
import { DefaultInputFilter, DateRadio } from 'redux/global.consts';
import { useQuery } from 'react-query';
import Skeleton from 'react-loading-skeleton';
import { DashboardContext } from 'context/DashboardContext';

const Holder = styled.div`
	display: flex;
	flex-direction: column;
	align-items: end;
	padding-left: 3.5rem;
	padding-right: 3rem;
	margin-top: 1rem;
`;

const Label = styled.span`
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`;

const StatisticsBox = styled.div`
	display: flex;
	flex-direction: column;
	align-items: end;
	border-left: 1px solid #ababab;
	margin-left: 3rem;
`;

const FormLabel = styled.label`
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`;

const NonRegisteredReportForm = ({ title, reportType }) => {
	const { currentTab } = useContext(DashboardContext);

	const [selectedInput, setSelectedInput] = useState(DefaultInputFilter);
	const [selectedMonth, setSelectedMonth] = useState();
	const [filterQuery, setFilterQuery] = useState();

	const { data: reportsData, isLoading } = useQuery(
		[`get-non-registered-${reportType}`, filterQuery],
		() => reportType === 'buy'
			? getNonRegisteredBuysReport(filterQuery)
			: getNonRegisteredDistsReport(filterQuery),
		{
			refetchOnWindowFocus: false,
			enabled: currentTab === reportType,
		}
	);

	const { data: inputsData } = useQuery(
		["get-inputs"],
		() => getInputs(),
		{
			refetchOnWindowFocus: false,
			enabled: currentTab === reportType,
		}
	);

	const getInputOtions = () => {
		if (inputsData?.data) {
			const inputOptions = inputsData.data.map((input, index) => {
				return { value: input?.item_id, label: input?.name };
			});

			return [DefaultInputFilter, ...inputOptions];
		}

		return [];
	};

	const getItems = () => reportsData?.data ?? [];
	const isEmpty = () => getItems().length < 1;

	const getReportVerb = reportType => {
		if (reportType === 'distribute') {
			return 'توزیع';
		}

		return 'خرید';
	};

	const getMonthOptions = () =>
		new PersianDate().getMonthNames().map((month, index) => {
			return { value: index + 1, label: month };
		});

	const onFilterTap = () => {
		let filterQuery = '?';

		if ((selectedInput?.value ?? 0) > 0) {
			filterQuery += `input_id=${selectedInput.value}&`;
		}
		if ((selectedMonth?.value ?? 0) > 0) {
			// filterQuery += `input_id=${selectedMonth.value}&`;
		}

		setFilterQuery(filterQuery);
	};

	return (
		<Holder>
			<div className="mb-2">{title}</div>
			<Card>
				<div className="mt-1 d-flex justify-content-between align-items-center">
					<CustomButton onClick={onFilterTap}>نمایش</CustomButton>
					<CustomSelect
						className="ms-3 me-2 w-100"
						radius="18"
						options={getInputOtions()}
						onChange={setSelectedInput}
						value={selectedInput}
						menuPosition='fixed'
					/>
					<CustomSelect
						className="mx-2 w-100"
						radius="18"
						placeholder='ماه'
						options={getMonthOptions()}
						onChange={setSelectedMonth}
						value={selectedMonth}
						menuPosition='fixed'
					/>
				</div>
			</Card>
			<Card className="mt-4">
				<div className="d-flex align-items-center justify-content-between">
					{isLoading ? (
						<div className='w-100 px-2'>
							<Skeleton count={6} height={20} />
						</div>
					) : (
						isEmpty() ? (
							<EmptyLabel className='w-100'>
								رکوردی ثبت نشده است
							</EmptyLabel>
						) : (
							<CommonTable
								cols={['شماره تماس کاربر', 'نام کاربر', 'نام استان', 'ردیف']}
								tablewidth="100%"
								className='ps-4'
							>
								{getItems().map((item, index) => (
									<tr key={index}>
										<td>{item.ceo_phone_number}</td>
										<td>{item.ceo_name}</td>
										<td>{item.province?.name}</td>
										<td>{index + 1}</td>
									</tr>
								))}
							</CommonTable>
						)
					)}
				</div>
			</Card>
		</Holder>
	);
};

export default NonRegisteredReportForm;
